module.exports = __webpack_public_path__ + "static/en-sm-2-cd635617a29e5a910d0bb36971fbc455.png";